module.exports = __webpack_public_path__ + "1cecb90bd4073bb925c16d0612bdb052.png";